export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";